import React from "react";
import { useLocation } from "react-router-dom";

// Components
// todo : lazy load or code split components
import SEO from "components/CBSEO";
import SchemaComponent from "components/CBSchema";
import StartYourJourney from "./components/startYourJourney";
import ResourcesSlider from "./components/resourcesSlider";
// import Packages from "./components/packages";
import CBDivider from "components/CBDivider";
// import ScienceBehind from "./components/ScienceBehind";
import StateMap from "./components/StateMap";
import KeyMechanics from "./components/KeyMechanics";
import MutualBenefits from "./components/MutualBenefits";
import ClinicalResearch from "./components/ClinicalResearch";
import GetStartedToday from "./components/GetStartedToday";
// import Header from "./components/Header";
import WaitList from "./components/Waitlist";
import HowItWorks from "components/CBHowItWorks";
import Calendar from "./components/Calendar/calendar";
import TrackProgress from "./components/TrackProgress/trackProgress";

// Styled Components
import { StyledPageContainer } from "styles/components/PageContainer/index.styles";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import { ImageContainer } from "styles/components/imageContainer";

// Utils
import { constructSchemaData } from "utils/helpers/constructSchemaData";

// Hook
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";

// Data
// a. Schema
import ketamineTherapySeoData from "./data/seoData/ketamineTherapySeo.data.json";
import psilocybinTherapySeoData from "./data/seoData/psilocybinTherapySeo.data.json";
import traditionalTherapySeoData from "./data/seoData/traditionalTherapySeo.data.json";
// a. Seo
import ketamineSchemaData from "./data/schemaData/ketamineTherapySchema.data.json";
import psilocybinSchemaData from "./data/schemaData/psilocybinSchema.data.json";
import traditionalTherapySchemaData from "./data/schemaData/traditionalTherapySchema.data.json";
// a. page content
import ketamineTherapyContent from "./data/pageContentData/ketamineTherapyContent.data.json";
import MOCK_psilocybinTherapyContent from "./data/pageContentData/psilocybinTherapyContent.data.json";
import MOCK_traditionalTherapyContent from "./data/pageContentData/traditionalTherapyContent.data.json";
import onlineTherapyContent from "./data/pageContentData/onlineTherapyContent.data.json";
import onlineTherapySeoData from "./data/seoData/onlineTherapy.data.json";
import onlineTherapySchemaData from "./data/schemaData/onlineTherapySchema.data.json";

// Components from other pages
// import StateHeader from "pages/TherapyState/components/StateHeader";
// import RealPeopleRealResults from "pages/TherapyState/components/RealPeopleRealResults";
import FeaturedBlogs from "./components/FeaturedBlogs";
// import CheckInsurance from "./components/CheckInsurance";
import InsuranceSection from "components/InsuranceSection";
import TextBlock from "components/TextBlock";
import DynamicHero from "components/DynamicHero";
import Testimonials from "components/Testimonials";
import FAQContent from "components/CBFAQ";
import Page404 from "pages/404";

// Mapping data to modalityType to render the content, seo, and schema data or components for each modality
const therapyHubContentMap = {
  "online-therapy": onlineTherapyContent,
  "ketamine-therapy": ketamineTherapyContent,
  "psilocybin-therapy": MOCK_psilocybinTherapyContent,
  "traditional-therapy": MOCK_traditionalTherapyContent,
};
const therapyHubSeoDataMap = {
  "online-therapy": onlineTherapySeoData,
  "ketamine-therapy": ketamineTherapySeoData,
  "psilocybin-therapy": psilocybinTherapySeoData,
  "traditional-therapy": traditionalTherapySeoData,
};

const therapyHubSchemaDataMap = {
  "online-therapy": onlineTherapySchemaData,
  "ketamine-therapy": ketamineSchemaData,
  "psilocybin-therapy": psilocybinSchemaData,
  "traditional-therapy": traditionalTherapySchemaData,
};

// Components that expect props to be spread directly
const SPREAD_PROPS_COMPONENTS = ["DynamicHero", "TextBlock", "ThreeColumnSection", "Testimonials", "HowItWorks", "TwoColumnSection"];

// Component Map - mapping component type strings to React components
const componentMap = {
  "FeaturedBlogs": FeaturedBlogs,
  "StartYourJourney": StartYourJourney,
  "ResourcesSlider": ResourcesSlider,
  "StateMap": StateMap,
  "KeyMechanics": KeyMechanics, // ! clean up design?
  "MutualBenefits": MutualBenefits, // ! clean up design?
  "ClinicalResearch": ClinicalResearch,
  "GetStartedToday": GetStartedToday, // move to general components
  "Waitlist": WaitList,
  "HowItWorks": HowItWorks,
  "Calendar": Calendar,
  "TrackProgress": TrackProgress,
  "Faq": FAQContent,
  "Divider": CBDivider,
  "ImageContainer": ImageContainer,
  "TwoColumnSection": TwoColumnSection,
  // "CheckInsurance": CheckInsurance,
  "InsuranceSection": InsuranceSection,
  "TextBlock": TextBlock,
  "DynamicHero": DynamicHero,
  "Testimonials": Testimonials,
};

const TherapyHub = () => {
  const location = useLocation();
  const modalityType = location.pathname.split("/")[1];
  const content = therapyHubContentMap[modalityType];
  const seoData = therapyHubSeoDataMap[modalityType];
  const schemaDataRaw = therapyHubSchemaDataMap[modalityType];
  const schemaData = schemaDataRaw.url ? constructSchemaData(schemaDataRaw.url, schemaDataRaw.breadcrumbs) : [];

  const renderedComponents = useDynamicPageRenderer(content, componentMap, SPREAD_PROPS_COMPONENTS);

  if (!content || content.length === 0) {
    return <Page404 />;
  }

  return (
    <StyledPageContainer id={`${modalityType}-therapy-hub-page-container`}>
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      <SchemaComponent schemas={schemaData} />

      {renderedComponents}
    </StyledPageContainer>
  );
};

export default TherapyHub;
